import { format } from 'date-fns';

export function FormatDate(timestamp, formatStr = 'PP') {
  // Converts timestamp to Date object if it's not already one
  const date = timestamp instanceof Date ? timestamp : new Date(timestamp);
  return format(date, formatStr);
}
